import { fetcher } from '#lib/backendFetcher';

/**
 * Fetches all post mailing templates.
 * @returns {Promise<Object>}
 */
export const listPostMailingTemplates = () => fetcher('/api/v1/post-mailing/templates');

/**
 * Fetches a single post mailing template by ID.
 * @param {string} id - Template ID
 * @returns {Promise<Object>}
 */
export const getPostMailingTemplate = (id) => fetcher(`/api/v1/post-mailing/templates/${id}`);

/**
 * Creates a new post mailing template.
 * @param {Object} payload - Template data (name, content, settings)
 * @returns {Promise<Object>}
 */
export const createPostMailingTemplate = (payload) =>
	fetcher('/api/v1/post-mailing/templates', { method: 'POST', body: payload });

/**
 * Updates an existing post mailing template.
 * @param {string} id - Template ID
 * @param {Object} payload - Fields to update
 * @returns {Promise<Object>}
 */
export const updatePostMailingTemplate = (id, payload) =>
	fetcher(`/api/v1/post-mailing/templates/${id}`, { method: 'PATCH', body: payload });

/**
 * Deletes a post mailing template by ID.
 * @param {string} id - Template ID
 * @returns {Promise<Object>}
 */
export const deletePostMailingTemplate = (id) => fetcher(`/api/v1/post-mailing/templates/${id}`, { method: 'DELETE' });

/**
 * Renders a one-page A4 preview PDF for a template (server-side). For PDF templates the optional body
 * selects the mock recipient and toggles the address-window guides.
 * @param {string} id - Template ID
 * @param {Object} [body] - { variant: 'sample'|'longName', guides: boolean, crmContactId? | crmCompanyId? }
 *   (a CRM recipient replaces the mock one)
 * @returns {Promise<Blob>} The PDF as a Blob.
 */
export const previewTemplatePdf = (id, body = {}) =>
	fetcher(`/api/v1/post-mailing/templates/${id}/preview-pdf`, { method: 'POST', body, responseType: 'blob' });
